import "./styles/index.scss";

import { createRoot } from 'react-dom/client';

import App from "./App";
import { AppProvider } from "./contexts/App/AppContext";

const root = createRoot(document.getElementById('co2-form-root'));
__webpack_public_path__ = co2_form_info.bundlesUrl;

import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'

import { messages as it } from '../src/locales/it/messages';
import { messages as en } from '../src/locales/en/messages';
import { messages as fr } from '../src/locales/fr/messages';
import { messages as de } from '../src/locales/de/messages';

import { en as enP, it as itP, fr as frP, de as deP } from 'make-plural/plurals';

switch (co2_form_info.lang) {
    case "en":
        i18n.load('en', en);
        i18n.loadLocaleData({ en: { plurals: enP } });
        i18n.activate('en');
        break;
    case "fr":
        i18n.load('fr', fr);
        i18n.loadLocaleData({ fr: { plurals: frP } });
        i18n.activate('fr');
        break;
    case "de":
        i18n.load('de', de);
        i18n.loadLocaleData({ de: { plurals: deP } });
        i18n.activate('de');
        break;
    //case "it":
    default:
        i18n.load('it', it);
        i18n.loadLocaleData({ it: { plurals: itP } });
        i18n.activate('it');
        break;
}

root.render(
    <I18nProvider i18n={i18n}>
        <AppProvider>
            <App />
        </AppProvider>
    </I18nProvider>

);
